export default function BackdropSvg({
  color = "#FF5E26", // primary / punchup orange
  className,
  width = "100",
  height = "97",
}: {
  color?: string;
  className?: string;
  width?: string;
  height?: string;
}) {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-auto"
      >
        <path
          d="M12.3683 26.6987L18.1687 28.8158L14.0032 35.1241C12.3429 37.5531 13.1155 41.0174 15.5546 42.6569C16.8661 43.5293 18.4589 43.7085 19.889 43.3253C21.1851 42.978 22.22 42.2373 22.9969 41.1143L30.8597 29.0747C31.7432 27.7687 32.0394 26.014 31.4338 24.3347C30.8697 22.8106 29.7715 21.5722 28.0629 20.9607L16.0974 16.5272C13.1931 15.4757 10.1939 16.8852 9.11259 19.777C8.00386 22.5216 9.44992 25.6391 12.3572 26.7017L12.3683 26.6987Z"
          fill={color}
        />
        <path
          d="M63.616 30.0767C64.8503 30.6609 66.2622 30.7459 67.413 30.4376C68.8543 30.0514 70.1329 29.1028 70.8325 27.6916C72.1251 25.0522 71.1006 21.8098 68.4096 20.3922L61.6481 17.0119L65.6128 12.2782C67.6022 9.91543 67.2928 6.48148 64.9603 4.65893C62.5892 2.69227 59.1305 3.01306 57.2864 5.33692L48.8889 15.3811C47.8215 16.582 47.383 18.3866 47.6566 19.9886C47.9301 21.5905 49.067 22.9731 50.5237 23.8065L63.5937 30.0827L63.616 30.0767Z"
          fill={color}
        />
        <path
          d="M75.0253 38.7814L17.5747 54.1753C13.4072 55.2919 10.8452 59.4953 11.8079 63.6691C13.0765 68.9846 17.3391 76.8485 25.9202 81.8799C31.7716 85.3497 41.9238 88.7364 56.7166 84.7727C71.5094 80.8089 78.5969 72.8029 81.9407 66.8692C86.7112 58.2603 86.5774 49.1356 85.0569 44.042C83.6199 39.8409 79.338 37.6258 75.0253 38.7814ZM33.9751 75.7414C38.156 70.6527 44.002 66.6388 51.1862 64.7138C58.3703 62.7888 65.4401 63.342 71.6052 65.6584C67.8214 70.4862 61.958 73.8989 54.204 75.9765C46.4501 78.0542 39.6688 78.0415 33.9751 75.7414Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
